import IconButton, { IconButtonKind, IconButtonSize } from '@/components/UI/Buttons/IconButton/IconButton'
import styles from './VPadDevCard.module.css'
import VPadIcon from '@/assets/img/Icon_VPad.svg'
import CrossIcon from '@/assets/img/Icon_Cross.svg'
import { useModalStore } from '@/stores/useModalStore'
import UnpairVPadModal from '../../UnpairVPadModal/UnpairVPadModal'
import { VPadUI } from '@/stores/usePadsStore'
import { VPadStage } from '@/interfaces/virtualPad_types'
import { useTranslations } from 'next-intl'

interface VPadDevCardProps {
  vPad: VPadUI
}

export default function VPadDevCard ({ vPad }: VPadDevCardProps) {
  const t = useTranslations('Modals.GamepadsManager.VPadDevCard')
  const openModal = useModalStore(state => state.openModal)
  const deviceName = vPad.deviceName ? vPad.deviceName : vPad.connectionId

  /**
   * Opens the unpair confirmation modal for the selected virtual pad
   * 
   * @param connectionId Virtual pad connection identifier
   * @param deviceName Name displayed for the virtual pad
   */
  function handleUnpair (connectionId: string, deviceName: string) {
    openModal({
      content: <UnpairVPadModal connectionId={connectionId} deviceName={deviceName} />
    })
  }

  return (
    <div className={styles.VPadDevCard}>
      <div className={styles.infoWrapper}>
        <VPadIcon className={styles.icon} />
      </div>

      <div className={styles.contentWrapper}>
        <p className={`bodyTextLargeStrong`}>{deviceName}</p>

        <div className={`${styles.statusWrapper} ${styles[vPad.stage]}`}>
          <div className={styles.statusLabel}>
            <div className={styles.ellipse}></div>
            <p className={`bodyTextSmallStrong`}>
              {vPad.stage === VPadStage.CONNECTED ? t('stages.connected') : t('stages.disconnected')}
            </p>
          </div>
          
          {vPad.stage === VPadStage.SUSPENDED && <p className={`labelTextXS`}>{t('openSoraApp')}</p>}
        </div>
      </div>

      <div className={styles.optionsWrapper}>
        <IconButton
          icon={CrossIcon}
          kind={IconButtonKind.FILLED}
          size={IconButtonSize.S}
          onClick={() => handleUnpair(vPad.connectionId, deviceName)}
        />
      </div>
    </div>
  )
}